import { Link } from 'react-router-dom';
import { useApp } from '../lib/contexto';
import { Boton, MensajeError, Tarjeta } from '../ui/base';

/**
 * Elegir con qué negocio se trabaja. Solo eso: crear un negocio se hace en `/crear-negocio`, y el
 * enrutador lleva allí a quien no tiene ninguno.
 */
export function Selector() {
  // Solo negocios propios: los entornos de prueba de la plataforma no son negocios de nadie
  // y se alcanzan desde el menú de cuenta.
  const { negociosPropios, elegirNegocio, salir, recargarMembresias, esSuperadmin, fallóCarga } = useApp();

  /**
   * Con la consulta de membresías fallida no se sabe si esta persona tiene negocios, así que no se
   * decide nada: un parpadeo de red no debe llevar a crear un segundo negocio.
   */
  if (fallóCarga) {
    return (
      <main className="flex min-h-full items-center justify-center p-4">
        <Tarjeta className="w-full max-w-3xl">
          <h1 className="mb-2 text-titulo font-extrabold">No pudimos leer tus negocios</h1>
          <MensajeError>Revisa la conexión e inténtalo de nuevo.</MensajeError>
          <div className="mt-4 flex items-center justify-between gap-2">
            <Boton onClick={() => void recargarMembresias()} data-e2e="reintentar-membresias">
              Reintentar
            </Boton>
            <button onClick={() => void salir()} className="text-info text-contenido underline">
              Salir
            </button>
          </div>
        </Tarjeta>
      </main>
    );
  }

  return (
    <main className="flex min-h-full items-center justify-center p-4">
      <Tarjeta className="w-full max-w-3xl">
        <h1 className="mb-4 text-titulo font-extrabold">¿Con cuál negocio vas a trabajar?</h1>
        <ul className="mb-4 space-y-2">
          {negociosPropios.map((m) => (
            <li key={m.membresiaId}>
              <button
                onClick={() => elegirNegocio(m.negocioId)}
                className="rounded-card bg-surface hover:bg-primary/15 flex w-full items-center justify-between px-4 py-3 text-left"
              >
                <span className="font-bold">{m.negocioNombre}</span>
                <span className="text-muted text-contenido">{m.rol}</span>
              </button>
            </li>
          ))}
        </ul>
        <div className="flex items-center justify-between gap-2">
          {esSuperadmin === true ? (
            <Link to="/panel" className="text-info text-contenido underline">
              Ir al panel
            </Link>
          ) : (
            <span />
          )}
          <button onClick={() => void salir()} className="text-info text-contenido underline">
            Salir
          </button>
        </div>
      </Tarjeta>
    </main>
  );
}
